import React from 'react'
import Head from 'next/head'
import ChromatogramSearchPage from '@src/routes/ChromatogramSearch'
import { useIntl } from 'react-intl'
import getConfig from 'next/config'
import ErrorPage from '@src/pages/_error'

const ChromatogramSearch = () => {
  const intl = useIntl()

  const {
    publicRuntimeConfig: { featureFlags },
  } = getConfig()
  if (featureFlags.chromatogramSearch) {
    return (
      <React.Fragment>
        <Head>
          <title>
            {intl.formatMessage({
              id: 'CHROMATOGRAM_SEARCH',
              defaultMessage: 'Chromatogram Search',
            })}
          </title>
        </Head>
        <ChromatogramSearchPage />
      </React.Fragment>
    )
  } else {
    return <ErrorPage statusCode={404} />
  }
}
export default ChromatogramSearch
